import { useState, useMemo } from 'react';
import { STATUS_LABELS } from '@launchpad/shared';

const COLUMNS = [
  { key: 'company', label: 'Company' },
  { key: 'role', label: 'Role' },
  { key: 'status', label: 'Status' },
  { key: 'dateApplied', label: 'Date Applied' },
  { key: 'priority', label: 'Priority' },
];

export function ListView({ applications, onCardClick }) {
  const [sortKey, setSortKey] = useState('dateApplied');
  const [sortDir, setSortDir] = useState('desc');

  const sorted = useMemo(() => {
    return [...applications].sort((a, b) => {
      const aVal = a[sortKey] || '';
      const bVal = b[sortKey] || '';
      const cmp = String(aVal).localeCompare(String(bVal), undefined, { numeric: true });
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }, [applications, sortKey, sortDir]);

  function handleSort(key) {
    if (sortKey === key) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left">
            {COLUMNS.map((col) => (
              <th
                key={col.key}
                onClick={() => handleSort(col.key)}
                className="cursor-pointer px-4 py-2 font-medium text-slate-600 hover:text-slate-900 select-none"
              >
                {col.label}
                {sortKey === col.key && (
                  <span className="ml-1 text-xs">{sortDir === 'asc' ? '↑' : '↓'}</span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sorted.map((app) => (
            <tr
              key={app.appId}
              onClick={() => onCardClick?.(app)}
              className="cursor-pointer border-b border-slate-100 hover:bg-slate-50"
            >
              <td className="px-4 py-2 font-medium text-slate-900">{app.company}</td>
              <td className="px-4 py-2 text-slate-700">{app.role}</td>
              <td className="px-4 py-2">
                <span className="rounded bg-slate-100 px-2 py-0.5 text-xs font-medium">
                  {STATUS_LABELS[app.status] || app.status}
                </span>
              </td>
              <td className="px-4 py-2 text-slate-600">{app.dateApplied || '—'}</td>
              <td className="px-4 py-2 text-slate-600 capitalize">{app.priority || '—'}</td>
            </tr>
          ))}
          {sorted.length === 0 && (
            <tr>
              <td colSpan={5} className="px-4 py-8 text-center text-slate-400">No applications yet</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
